const PATTERNS = [
    "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
    "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
    "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
    "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
    "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
    "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
    "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
    "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
    "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
    "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
    "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
];

const START_B = 104;
const STOP = 106;

export function statusBarcodePayload(code) {
    return `STATUS;${String(code).padStart(6, "0")}`;
}

export function appointmentBarcodePayload(orderNumber, operationNumber, quantity) {
    return `${orderNumber};${operationNumber};${quantity}`;
}

function code128Values(text) {
    const values = [START_B];
    for (let i = 0; i < text.length; i += 1) {
        const value = text.charCodeAt(i) - 32;
        if (value < 0 || value > 95) {
            throw new Error(`Caractere inválido para Code 128: ${text[i]}`);
        }
        values.push(value);
    }
    const checksum = values.reduce((sum, value, index) => sum + value * (index === 0 ? 1 : index), 0) % 103;
    values.push(checksum, STOP);
    return values;
}

function modulesFromValues(values) {
    const modules = [];
    values.forEach((value) => {
        const pattern = PATTERNS[value];
        for (let i = 0; i < pattern.length; i += 1) {
            modules.push({
                black: i % 2 === 0,
                width: Number(pattern[i])
            });
        }
    });
    return modules;
}

export function buildCode128Svg(text) {
    const modules = modulesFromValues(code128Values(text));
    const quiet = 10;
    const moduleWidth = 2;
    const height = 80;
    const contentWidth = modules.reduce((sum, module) => sum + module.width, 0);
    const width = (quiet + contentWidth + quiet) * moduleWidth;

    let x = quiet * moduleWidth;
    const bars = modules
        .map((module) => {
            const rect = module.black
                ? `<rect x="${x}" y="0" width="${module.width * moduleWidth}" height="${height}" fill="#000"/>`
                : "";
            x += module.width * moduleWidth;
            return rect;
        })
        .join("");

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img" aria-label="${text}">${bars}</svg>`;
}

export function buildCode128DataUri(text) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(buildCode128Svg(text))}`;
}
